"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAppType = void 0;
const EnumObject_1 = require("./EnumObject");
const enumValues = {
    WEB: "W",
    UNITY: "U",
    MAINTENANCE: "M",
    IMPORT: "I",
    TESTING: "T",
    ADMIN: "A",
    SERVICE_CORE: "SC",
    SERVICE_EXTERNAL: "SE",
    GRAPHIC_WORKER_AUTO: "GA",
};
class EAppType extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static create(p) {
        return new EAppType(p);
    }
}
exports.EAppType = EAppType;
EAppType.V = enumValues;
//# sourceMappingURL=EAppType.js.map